import { render, staticRenderFns } from "./DocumentPagesPagination.vue?vue&type=template&id=d8339526&scoped=true"
import script from "./DocumentPagesPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentPagesPagination.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DocumentPagesPagination.vue?vue&type=style&index=0&id=d8339526&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8339526",
  null
  
)

export default component.exports